module.exports = __webpack_public_path__ + "img/screen-bubble-options.cb5d2a04.jpg";